import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";
import { BackgroundIcon } from "../../../../ProgressBarView/icons/BackgroundIcon";
import { ProgressBarIcon } from "../../../../ProgressBarView/icons/ProgressBarIcon";
import { ProgressBarBreakpoint } from "../../../../ProgressBarView/types";
import { cls } from "../../../../util";

interface BreakpointIconProps {
  className?: string;
  breakpoint: ProgressBarBreakpoint;
}

export const BreakpointIcon = (props: BreakpointIconProps) => {
  const { breakpoint, className } = props;
  const context = useProgressBarContext();
  const { activeColor, activeIconColor, inactiveColor, inactiveIconColor } =
    context.device.widget.styles.breakpoint;
  const completed = breakpoint.progress >= 100;

  return (
    <Container className={cls("ig-icon", className)}>
      <Background
        color={completed ? activeColor : inactiveColor}
        id={
          completed
            ? (breakpoint.active.backgroundIconId ?? "circle")
            : (breakpoint.inactive.backgroundIconId ?? "circle")
        }
      />
      <Icon
        color={
          breakpoint.progress === 100 ? activeIconColor : inactiveIconColor
        }
        id={
          completed
            ? (breakpoint.active.iconId ?? "check")
            : (breakpoint.inactive.iconId ?? "lockClosed")
        }
      />
    </Container>
  );
};

const Container = styled("div")(() => {
  const { device } = useProgressBarContext();
  return {
    height: device.widget.styles.breakpoint.size,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    position: "relative",
  };
});

const Background = styled(BackgroundIcon)(() => {
  const { device } = useProgressBarContext();
  const { size } = device.widget.styles.breakpoint;
  return {
    width: size,
    minWidth: size,
    height: size,
    minHeight: size,
  };
});

const Icon = styled(ProgressBarIcon)(() => {
  const { device } = useProgressBarContext();
  const { size, iconSize } = device.widget.styles.breakpoint;

  return {
    position: "absolute",
    width: iconSize ?? Math.round(0.55 * size),
    minWidth: iconSize ?? Math.round(0.55 * size),
    height: iconSize ?? Math.round(0.55 * size),
    minHeight: iconSize ?? Math.round(0.55 * size),
  };
});
